function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useState, useEffect } from "react";
import Storages from "js-storage";
import Cookies from "js-cookie";
export var DateListener = /*#__PURE__*/_createClass(function DateListener(_key, opts, initialValue) {
  var _this = this;
  _classCallCheck(this, DateListener);
  _defineProperty(this, "key", void 0);
  _defineProperty(this, "value", void 0);
  _defineProperty(this, "opts", {
    setCookies: false,
    setLocalStorage: false,
    setSessionStorage: false,
    setWindow: false
  });
  _defineProperty(this, "getValue", function () {
    if (_this.opts.setCookies) {
      return Cookies.get(_this.key);
    } else if (_this.opts.setLocalStorage) {
      return Storages.localStorage.get(_this.key);
    } else if (_this.opts.setSessionStorage) {
      return Storages.sessionStorage.get(_this.key);
    } else if (_this.opts.setWindow) {
      return window[_this.key];
    } else {
      return _this.value;
    }
  });
  _defineProperty(this, "setValue", function (value) {
    if (_this.opts.setCookies) {
      Cookies.set(_this.key, value);
    }
    if (_this.opts.setLocalStorage) {
      Storages.localStorage.set(_this.key, value);
    }
    if (_this.opts.setSessionStorage) {
      Storages.sessionStorage.set(_this.key, value);
    }
    if (_this.opts.setWindow) {
      window[_this.key] = value;
    }
    _this.value = value;
    var event = new Event(_this.key);
    event.key = _this.key;
    event.newValue = value;
    window.dispatchEvent(event);
  });
  _defineProperty(this, "listener", function (callback) {
    var key = _this.key;
    function _eventFn(e) {
      window.setTimeout(function () {
        callback(e.newValue);
      });
    }
    function storageFn(e) {
      window.setTimeout(function () {
        var _value = e.newValue;
        e.key === key && callback(_value && JSON.parse(_value));
      });
    }
    //当前tab页有效
    window.addEventListener(key, _eventFn);
    //非当前tab页有效
    if (_this.opts.setLocalStorage) {
      window.addEventListener("storage", storageFn);
    }
    return function () {
      window.removeEventListener(key, _eventFn);
      if (_this.opts.setLocalStorage) {
        window.removeEventListener("storage", storageFn);
      }
    };
  });
  _defineProperty(this, "useValueListener", function () {
    var _useState = useState(_this.getValue()),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];
    useEffect(function () {
      var removeListener = _this.listener(function (newValue) {
        if (newValue !== value) {
          setValue(newValue);
        }
      });
      return function () {
        removeListener();
      };
    }, [value]);
    return value;
  });
  this.key = _key;
  this.opts = opts || this.opts;
  if (initialValue !== undefined && (this.getValue() === undefined || this.getValue() === null)) {
    this.setValue(initialValue);
  }
});